<template>
    <div class="patient-appointment" v-if="provider.id">

        <b-row no-gutters>
            <b-col class="pt-1">
                <timestamp class="d-inline"
                           :date="provider.appointment"
                           :is-mysql-date="true">
                </timestamp>
            </b-col>

            <b-col>
                <b-btn variant="primary" size="sm" class="px-2 ml-2 btn-ghost-blue"
                       @click.stop="showModal()">
                    <b-icon icon="pencil"></b-icon>
                </b-btn>
            </b-col>
        </b-row>

        <b-modal :id="modalId"
                 :title="$i18n.gt('LABEL_EDIT_APPOINTMENT')"
                 @ok="updateAppointment()">

            <div class="text-center mb-3">
                <patient-id :participant="provider.participant">
                </patient-id>
            </div>

            <b-form-group :label="$i18n.gt('LABEL_NEXT_APPOINTMENT')">
                <input class="form-control"
                       type="date"
                       v-model="appointment">
            </b-form-group>

            <b-alert show variant="info">
                <p v-html="$i18n.gt('MESSAGE_APPOINTMENT_INSTRUCTIONS')"></p>
            </b-alert>

        </b-modal>
    </div>
</template>

<script>

    import Vue from 'vue'
    import PractitionerPatientMixin from '@/providers/PractitionerPatientMixin'

    export default Vue.extend({
        name: 'PatientAppointment',
        props: {
            provider: Object
        },
        data() {
            return {
                appointment: this.provider.appointment
            }
        },
        computed: {
            modalId() {
                return `patient-appointment-${this.provider.id}`
            }
        },
        methods: {
            showModal() {
                this.$bvModal.show(this.modalId)
            },
            async updateAppointment() {
                this.provider.appointment = this.appointment
                await this.$api.updateAppointment(this, this.provider)
                this.$toasted.show('Appointment updated', { duration: 3000 })
            },
        }
    })
</script>

<style lang="scss">

</style>
